import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
// import { TruncatePipe } from "src/app/pipe/truncate.pipe";
declare var $:any;

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent {

  public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public searchtype:any='';
  public searchname:any='';
  public sortType:any='desc';

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

  getDetail(page:any){  
    this.loading = true;    
        var url='/transactions?page='+page
        if(this.searchKey !=''){
          url=url+'&search='+this.searchKey; 
        }  
        if(this.searchtype !=''){
          url=url+'&txnFor='+this.searchtype; 
        }    
        if(this.searchname !=''){
          url=url+'&role='+this.searchname; 
        } 
     url=url+'&sortBy=createdAt'+'&sortOrder='+this.sortType;
        this.service.GetApi(url).subscribe(((response:any)=>{  
        if(response.success ==1) {  
          this.dataListing= response.data.record;
          this.totalCount = response.data.total;   
          this.loading=false;
        } else {
          this.dataListing=[]; 
          this.totalCount = response.data.total;  
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  }  

  reset(){
    this.p=1;
    this.searchKey='';
    this.searchname='';
    this.searchtype='';
    this.getDetail(this.p);
  }
}
